export function Create(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/tax-rates`;
}

export function Delete(organizationID: number, groupID: number, taxRateID: string): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/tax-rates/${taxRateID}`;
}

export function Index(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/tax-rates`;
}

export function Update(organizationID: number, groupID: number, taxRateID: string): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/tax-rates/${taxRateID}`;
}

